import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Modal from './Modal';
import { useTranslation } from '../hooks/useTranslation';
import CustomAlert from './CustomAlert';

const DateTimePickerModal = ({ isOpen, onClose, onSave, minDate }) => {
  const t = useTranslation();

  // Use minDate as baseline if provided, else current time
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState(() => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  });

  // Reset when modal opens
  React.useEffect(() => {
    if (isOpen) {
      const now = new Date();
      setSelectedDate(now);
      setSelectedTime(
        `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
      );
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    const [hours, minutes] = selectedTime.split(':').map(Number);
    const finalDate = new Date(selectedDate);
    finalDate.setHours(hours, minutes, 0, 0);

    const now = new Date();
    // Allow a small buffer (1 minute) for user delay
    const bufferTime = new Date(now.getTime() - 60000);

    if (finalDate < bufferTime) {
      CustomAlert.warning(
        t('warning') || 'Warning',
        t('selected_date_time_cannot_be_in_the_past') || 'Selected date/time cannot be in the past!'
      );
      return;
    }

    onSave(finalDate);
  };

  return (
    <Modal modalStyle={{ width: '350px' }}>
      {/* Close Button (Top-Right) */}
      {/* <button onClick={onClose} style={styles.closeBtn}>✖</button> */}

      <h3 className="fs-12 fw-500 mt-0">{t('select_date_time')}</h3>

      <Calendar onChange={setSelectedDate} value={selectedDate} minDate={minDate || new Date()} />

      {/* Time Section */}
      <div style={styles.timeRow}>
        <label style={styles.timeLabel}>{t('select_time')}</label>
        <input
          type="time"
          value={selectedTime}
          onChange={(e) => setSelectedTime(e.target.value)}
          className="input width-50 p-6"
          step="300"
        />
      </div>

      {/* Save Button */}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <button onClick={onClose} className="button_secondary">
          {t('Cancel')}
        </button>
        <button onClick={handleSave} className="button_primary">
          {t('Save')}
        </button>
      </div>
    </Modal>
  );
};

const styles = {
  closeBtn: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'transparent',
    border: 'none',
    fontSize: '12px',
    cursor: 'pointer',
  },
  title: {
    marginBottom: '10px',
  },
  timeRow: {
    marginTop: '15px',
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 0px',
  },
  timeLabel: {
    fontSize: '12px',
    fontWeight: '500',
  },
  timeInput: {
    padding: '6px',
    width: '50%',
  },
  saveBtn: {
    marginTop: '20px',
    padding: '10px 20px',
    background: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    width: '100%',
    fontSize: '12px',
  },
};

export default DateTimePickerModal;
